"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformDateToUnixTimestamp = transformDateToUnixTimestamp;
function transformDateToUnixTimestamp(date) {
    return Number((date.getTime() / 1000).toFixed(0));
}
//# sourceMappingURL=transformDateToUnixTimestamp.js.map